module.exports = __webpack_public_path__ + "img/sns_google.330a2dc.svg";